module.exports = __webpack_public_path__ + "static/plans-list-a461cfb1d67cc59ba2d55f3d90f633b9.png";